import {waitForDependency} from "@js/globalFunctions/waitForDependency";
import SoegningBlockApp from "@vue/apps/SoegningBlockApp";
import Vuex from 'vuex'
import * as actions from '@vue/stores/soegning/actions';
import * as mutations from '@vue/stores/soegning/mutations';
import {isJsonString} from "@js/globalFunctions/isJsonString";
import {getCookie} from "@js/globalFunctions/cookieHandling";
import {triggerCallbackAfterEventOrIfFired, triggerDocumentEvent} from "@js/globalFunctions/events";
import {flattenSearchParams} from "../../src/entrypoints/blocks/search/flattenSearchParams";
let apps = {};

waitForDependency('vue',() => {
	triggerCallbackAfterEventOrIfFired('pageIsReadyForSearch',function(){
		initVue();
	});

});

function initVue(){
	if($('.block.soegning').length !== 0)
	{
		Vue.use(Vuex);
		$('.block.soegning').each((i,el) => {

			const store = initStore(el);
			apps[i] = new Vue({
				el: $(el).find('.soegning-app')[0],
				store,
				render: h => h(SoegningBlockApp)
			});
		})
	}
}

function initStore(el)
{
	const paramsRaw = $(el).attr('data-params');
	let params = {};
	if(typeof paramsRaw !== 'undefined' && isJsonString(paramsRaw))
		params = JSON.parse(paramsRaw);
	
	const favCookieRaw = (dataholder.lan === "da-dk") ? getCookie('favorithuse') : getCookie('favorithauser') ;
	const favCookie = (isJsonString(favCookieRaw)) ? JSON.parse(favCookieRaw) : [] ;
	const searchParamsOrder = getCookie('searchParamsDisplayOrder');
	const isMainSearch = $(el).attr('data-is-main-search') === '1';
	const paginationObject = determinePaginationObject(el,isMainSearch);
	const showSearchHeader =  $(el).attr('data-show-search-header') === '1';
	const mapPage =  $(el).attr('data-map-page');
	let sorting = 'default';
	if(isMainSearch)
		sorting = getCookie('searchOrder');
	
	const state = {
		translations: wpTranslatedStrings,
		lodgings: [],
		printIds: [],
		isSeoMode: paginationObject.isSeoMode,
		paginationType: paginationObject.paginationType,
		page: paginationObject.page,
		prPage: !isNaN($(el).attr('data-pr-page')) ? Number($(el).attr('data-pr-page')) : 10,
		totalCount: 0,
		altCount: false,
		maxPages: 1,
		svgIconUrl: themeUrl + '/gfx/icons/new-icons/',
		useRemoteLodgingImages: (typeof useRemoteLodgingImages === "boolean") ? useRemoteLodgingImages : false,
		favorites: favCookie,
		isLastMinute: dataholder.lastMinute,
		windowWidth: window.innerWidth,
		isMainSearch: isMainSearch,
		showSearchHeader: showSearchHeader,
		mapPage: mapPage,
		search: {
			parameters: flattenSearchParams(params),
			searchOrder: typeof sorting !== 'undefined' ? sorting : 'default',
			queryParameters: params,
			defaultParameters: params,
			parameterDisplayOrder: (typeof searchParamsOrder !== 'undefined' && isJsonString(searchParamsOrder)) ? JSON.parse(searchParamsOrder) : Array(),
		}
	};
	console.log(state);
	return new Vuex.Store({
		state: state,
		actions: actions,
		mutations: mutations
	});
}

function determinePaginationObject(el,isMainSearch)
{
	let object = {
		page: 1,
		paginationType: $(el).attr('data-pagination-type'),
		isSeoMode: false
	};
	
	if(isMainSearch)
	{
		const regex = /page=\/([0-9]+)/g;
		const match = regex.exec(window.location.hash);
		if(Array.isArray(match) && typeof match[1] !== 'undefined')
			object.page = Number(match[1]);
		else
		{
			const regex2 = /page\/([0-9]+)\//g;
			const match2 = regex2.exec(window.location.href);
			if(Array.isArray(match2) && typeof match2[1] !== 'undefined')
			{
				object.page = Number(match2[1]);
				object.isSeoMode = true;
				object.paginationType = 'page';
			}
		}
	}
	
	return object;
}
